export function stopPropagation(event) {
    event.stopPropagation();
}